import React from 'react';
import styles from './ActionModalWindowWrapper.module.scss';
import Modal from 'antd/lib/modal/Modal';
import { ActionOptions } from '../../../utils/Constants';
import Button from 'antd/lib/button';

export interface IActionModalWindowWrapper {
  showModalWindow: boolean;
  type: ActionOptions | null;
  selectedRows?: Array<any>;
  handleCancelButtonClick: () => void;
  handleOkButtonClick: () => void;
  handleNoButtonClick?: () => void;
  path: string;
  history: any;
}

const ActionModalWindowWrapper: React.FC<IActionModalWindowWrapper> = (props) => {
  const { showModalWindow, type, selectedRows, handleCancelButtonClick, handleOkButtonClick, handleNoButtonClick, path } = props;

  const renderRuleListLayout = () => {
    const multipleRows = selectedRows && selectedRows?.length > 1;
    return (
      <div>
        <div className={styles.ruleListLayoutText}>
          Are you sure you would like to {type?.toLowerCase()}
          {!multipleRows && (
            <span className={styles.selectedRow} onClick={() => selectedRows && handleRuleClick(selectedRows[0]?.id)}>
              {` ${(selectedRows && selectedRows[0]?.description) ?? 'this entity'}`}
            </span>
          )}
          {!multipleRows ? '?' : ':'}
        </div>
        {multipleRows && (
          <ul className={styles.selectedRowsList}>
            {selectedRows?.map((selectedRow: any) => (
              <li className={styles.selectedRow} onClick={() => handleRuleClick(selectedRow?.id)}>
                {selectedRow?.description ?? 'this entity'}
              </li>
            ))}
          </ul>
        )}
      </div>
    );
  };

  const renderUnsavedLayout = () => {
    return <p>You have unsaved changes. Do you want to save?</p>;
  };

  const handleRuleClick = (id: string) => window?.open(`/${path}/rule/${id}`, '_blank');

  const modalWindowSettings = {
    [ActionOptions.Delete]: {
      title: 'DELETE',
      layout: renderRuleListLayout,
    },
    [ActionOptions.Copy]: {
      title: 'COPY',
      layout: renderRuleListLayout,
    },
    [ActionOptions.Unsaved]: {
      title: 'Unsaved',
      layout: renderUnsavedLayout,
    },
  };

  const settings = type && modalWindowSettings[type as ActionOptions.Delete];

  return (
    <Modal
      open={showModalWindow}
      centered={true}
      destroyOnClose={true}
      title={settings?.title}
      className={styles.actionModalWindow}
      onCancel={handleCancelButtonClick}
      onOk={handleOkButtonClick}
      cancelText={'Cancel'}
      okText={'Yes'}
      closable={false}
      footer={
        type === ActionOptions.Unsaved
          ? [
              <Button key="back" type="primary" onClick={handleOkButtonClick}>
                Yes
              </Button>,
              <Button key="submit" type="primary" onClick={handleNoButtonClick}>
                No
              </Button>,
              <Button key="cancel" type="primary" onClick={handleCancelButtonClick}>
                Cancel
              </Button>,
            ]
          : undefined
      }
    >
      {settings?.layout()}
    </Modal>
  );
};

export default ActionModalWindowWrapper;
